import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createItemAvgEntry = createAsyncThunk('createItemAvgEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertItemAvg`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateItemAvgEntry = createAsyncThunk('updateItemAvgEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateItem`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchItemAvgData = createAsyncThunk('fetchItemAvgData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getItemAvglist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleItemAvg = createAsyncThunk('fetchSingleItemAvg', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getItemlist&itemId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleItemAvg = createAsyncThunk('deleteSingleItemAvg', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteItem&itemId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const itemAvgSlice = createSlice({
    name: 'ItemAvgData',
    initialState: {
        isLoading: false,
        itemAvg: null,
        deleteItemAvg: null,
        singleItemAvg: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchItemAvgData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchItemAvgData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.itemAvg = action.payload;
        });
        builder.addCase(fetchItemAvgData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleItemAvg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleItemAvg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteItemAvg = action.payload;
        });
        builder.addCase(deleteSingleItemAvg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleItemAvg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleItemAvg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleItemAvg = action.payload;
        });
        builder.addCase(fetchSingleItemAvg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default itemAvgSlice.reducer;
